import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdateId from "@/hooks/use-update-id";
import notificationService from "@/services/notification.service";
import { IdRequestProps } from "@/types/requests.types";

export type Props = IdRequestProps;

export type Return = {
  markAsRead: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useMarkAsReadNotification = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdateId<void>({
    operation: (id) => notificationService.markAsRead(id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, markAsRead: update };
};

export default useMarkAsReadNotification;
